/**
 * AngularJS fixed header scrollable table directive
 * @author Jason Watmore <jason@pointblankdevelopment.com.au> (http://jasonwatmore.com)
 * @version 1.2.0
 */
(function () {
    angular
        .module('anguFixedHeaderTable', [])
        .directive('fixedHeader', fixedHeader);

    fixedHeader.$inject = ['$timeout'];

    function fixedHeader($timeout) {
        return {
            restrict: 'A',
            link: link
        };

        function link($scope, $elem, $attrs, $ctrl) {
            var elem = $elem[0];

            // wait for data to load and then transform the table
            $scope.$watch(tableDataLoaded, function(isTableDataLoaded) {
                if (isTableDataLoaded) {
                    transformTable();
                }
            });

            function tableDataLoaded() {
                // first cell in the tbody exists when data is loaded but doesn't have a width
                // until after the table is transformed
                var firstCell = elem.querySelector('tbody tr:first-child td:first-child');
                return firstCell && !firstCell.style.width;
            }

            function transformTable() {
                    // reset display styles so column widths are correct when measured below
                    angular.element(elem.querySelectorAll('thead, tbody, tfoot')).css('display', '');

                    // wrap in $timeout to give table a chance to finish rendering
                    $timeout(function () {
                        // set widths of columns
                        angular.forEach(elem.querySelectorAll('tr:first-child th'), function (thElem, i) {

                            var tdElems = elem.querySelector('tbody tr:first-child td:nth-child(' + (i + 1) + ')');
                            var tfElems = elem.querySelector('tfoot tr:first-child td:nth-child(' + (i + 1) + ')');

                            var tdComputedStyle = window.getComputedStyle(tdElems, null),
                                thComputedStyle = window.getComputedStyle(tfElems, null),
                                tdWidth = tdComputedStyle.getPropertyValue("width"),
                                thWidth = thComputedStyle.getPropertyValue("width"),
                                tdPaddingLeft = tdComputedStyle.getPropertyValue("padding-left"),
                                tdPaddingRight = tdComputedStyle.getPropertyValue("padding-right"),
                                thPaddingLeft = thComputedStyle.getPropertyValue("padding-left"),
                                thPaddingRight = thComputedStyle.getPropertyValue("padding-right");


                            //var columnWidth = tdElems ? tdElems.offsetWidth: thElem.offsetWidth;
                            var columnWidth = tdElems ? parseFloat(tdWidth) : parseFloat(thWidth),
                                paddingLeft = tdElems ? parseFloat(tdPaddingLeft) : parseFloat(thPaddingLeft),
                                paddingRight = tdElems ? parseFloat(tdPaddingRight) : parseFloat(thPaddingRight);

                            if (tdElems) {
                                tdElems.style.paddingRight = (paddingRight)  + 'px';
                                tdElems.style.paddingLeft = (paddingLeft)  + 'px';
                                tdElems.style.width = (columnWidth)  + 'px';
                                tdElems.style.minWidth = (columnWidth) + 'px';
                            }
                            if (thElem) {
                                thElem.style.paddingRight = (paddingRight)  + 'px';
                                thElem.style.paddingLeft = (paddingLeft)  + 'px';
                                thElem.style.width = (columnWidth)  + 'px';
                                thElem.style.minWidth = (columnWidth) + 'px';
                            }
                            if (tfElems) {
                                tfElems.style.paddingRight = (paddingRight)  + 'px';
                                tfElems.style.paddingLeft = (paddingLeft)  + 'px';
                                tfElems.style.width = (columnWidth)  + 'px';
                                tfElems.style.minWidth = (columnWidth) + 'px';
                            }
                        });

                        // set css styles on thead and tbody
                        angular.element(elem.querySelectorAll('thead, tfoot')).css('display', 'block');

                        var myTbodyHeight = 0;
                        angular.forEach(elem.querySelectorAll('tbody tr'), function(trElem){
                            //myTbodyHeight += angular.element(trElem).css("height");
                            myTbodyHeight += trElem.clientHeight;
                        });

                        angular.element(elem.querySelectorAll('tbody')).css({
                            'display': 'block',
                            'height': $attrs.tableheight || 'inherit',
                            //'max-height': $attrs.tableHeight || 'inherit',
                            'overflow': 'scroll'
                        });

                        // reduce width of last column by width of scrollbar
                        var tbody = elem.querySelector('tbody');
                        var scrollBarWidth = tbody.offsetWidth - tbody.clientWidth;

                        if (scrollBarWidth > 0) {
                            // for some reason trimming the width by 2px lines everything up better
                            scrollBarWidth -= 2;
                            var lastColumn = elem.querySelector('tbody tr:first-child td:last-child');
                            lastColumn.style.width = (lastColumn.offsetWidth - scrollBarWidth) + 'px';

                        }

                        $timeout(function () {
                            var height = 30;

                            $(elem.tBodies[0]).children().each(function(index){
                                height += $(this).height();
                            });

                            $(elem.thead).children().each(function(index){
                                height += $(this).height();
                            });

                            $(elem.tfoot).children().each(function(index){
                                height += $(this).height();
                            });

                            $("#" + elem.id).height(height > (elem.parentElement.clientHeight)? elem.parentElement.clientHeight - 150: height);
                        });

                    });

            }
        }
    }
})();


// WEBPACK FOOTER //
// ./lib/angu-fixed-header-table/angu-fixed-header-table.js